import { Badge, Box, Tooltip } from '@chakra-ui/react'
import { offerStatusEnum } from 'BrokerTsLib/src/enums/offerStatusEnum'

export const StatusBadge = ({ status, tooltip }: { status: offerStatusEnum, tooltip?: string }) => {
  let colorScheme
  let text

  switch (status) {
    case offerStatusEnum.Error:
      colorScheme = 'red'
      text = 'Chyba'
      break
    case offerStatusEnum.Selected:
      colorScheme = 'green'
      text = 'Vybraná'
      break
    case offerStatusEnum.Valid:
      text = ''
      break
  }

  if (!text)
    return null

  const children = (
    <Badge sx={{ h: 4, py: 0, fontSize: 'xs' }} colorScheme={colorScheme}>
      {text}
    </Badge>)

  return (
    <>
      {!!tooltip &&
        <Tooltip hasArrow placement="top" label={<Box dangerouslySetInnerHTML={{ __html: tooltip }}></Box>}>
          {children}
        </Tooltip>
      }

      {!tooltip && children}
    </>
  )
}
